import { ComplaintForm } from "@/components/form/ComplaintForm";
import { HeroBanner } from "@/components/home/HeroBanner";
import { InfoPanel } from "@/components/home/InfoPanel";
import { LoginRequiredCard } from "@/components/home/LoginRequiredCard";
import { useAuth } from "@/context/AuthContext";

export default function ComplaintPage() {
  const { user } = useAuth();
  return (
    <main className="mx-auto max-w-7xl space-y-8 px-4 py-6 sm:px-6 sm:py-8 lg:px-8" data-testid="complaint-page">
      <HeroBanner />
      <div className="grid gap-8 lg:grid-cols-[minmax(0,1fr)_340px]">
        {user?.role === "warga" ? <ComplaintForm key={user.id} user={user} /> : <LoginRequiredCard user={user} />}
        <InfoPanel />
      </div>
    </main>
  );
}
